export const INVOICE_TYPE = {
  NFCE:      'NFCe',
  NFE:       'NFe',
  ORCAMENTO: 'ORC',
}

export const NOTE_MODEL_TYPE = {
  NFCE:      'NFC-e',
  NFE:       'NF-e',
  ORCAMENTO: 'ORC',
}
